import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { getCurrentDateTime } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 15,
    fontSize: 7
  },
  heading: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 15,
    fontWeight: 'bold'
  },
  headerRow: {
    flexDirection: 'row',
    backgroundColor: '#1976D2',
    minHeight: 35,
    alignItems: 'center',
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000',
    marginTop: 10,
    width: '100%'
  },
  dataRow: {
    flexDirection: 'row',
    minHeight: 30,
    alignItems: 'center',
    borderBottomWidth: 0.5,
    borderColor: '#ccc',
    width: '100%'
  },
  // Column width definitions - total exactly 100%
  colSrNo: { width: '3%', padding: 2 },
  colBillDate: { width: '5%', padding: 2 },
  colTime: { width: '4%', padding: 2 },
  colUhid: { width: '6%', padding: 2 },
  colOpNo: { width: '5%', padding: 2 },
  colPatientName: { width: '10%', padding: 8 },
  colGuardianName: { width: '7%', padding: 2 },
  colAge: { width: '2.5%', padding: 2 },
  colConsultant: { width: '7%', padding: 2 },
  colAddress: { width: '9%', padding: 2 },
  colCity: { width: '5%', padding: 2 },
  colState: { width: '5%', padding: 2 },
  colCategory: { width: '6%', padding: 2 },
  colMobile: { width: '6%', padding: 2 },
  colRefBy: { width: '5.5%', padding: 2 },
  colEntryBy: { width: '6%', padding: 2 },
  
  // Header text style
  headerText: {
    color: 'white',
    fontSize: 7,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 3,
    fontFamily: 'Helvetica-Bold'
  },
  // Cell text style
  cellText: {
    fontSize: 6.5,
    padding: 3,
    textAlign: 'left',
  },
  cellTextCenter: {
    fontSize: 6.5,
    padding: 3,
    textAlign: 'center',
  },
  logo: {
    width: '100%',
    height: 60,
    marginBottom: 10,
    objectFit: 'contain',
  },
  dateTimeRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    fontSize: 8,
    color: '#444'
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    right: 20,
    textAlign: 'center',
    fontSize: 7,
    color: '#666'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} size="A4" orientation="landscape" {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={style} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, children, content, ...props }) => (
  <PDFText style={style} {...props}>
    {content || children}
  </PDFText>
);

const COLORS = ['#f9f9f9', '#efefef'];

export const RegistrationRegisterReport = ({ data }) => {
  console.log(data, 'RegisterData');
  
  function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  function formatTime(timeString) {
    if (!timeString) return '';
    return timeString.substring(0, 5);
  }

  function calculateAge(dobString) {
    if (!dobString) return '';
    const dob = new Date(dobString);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    
    return age;
  }

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const currentDateTime = getCurrentDateTime();

  // Calculate total width to verify it's 100%
  const totalWidth = (
    3 + 5 + 4 + 6 + 5 + 8 + 7 + 2.5 + 7 + 9 + 5 + 5 + 6 + 6 + 5.5 + 6
  );
  console.log('Total columns width:', totalWidth + '%'); // Should be 100%

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Registration Register Report">
          <Page>
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={styles.logo}
            />
            
            <Text style={styles.heading}>Registration Register Report</Text>
            
            {/* <View style={styles.dateTimeRow}>
              <Text>Print Date: {formatDate(currentDateTime.date)}</Text>
              <Text>Print Time: {formatTime(currentDateTime.time)}</Text>
              <Text>Printed By: {user?.user?.fullname || 'N/A'}</Text>
            </View> */}
            
            {/* Header Row - Using full width */}
            <View style={styles.headerRow}>
              <Text style={{...styles.headerText, ...styles.colSrNo}}>Sr</Text>
              <Text style={{...styles.headerText, ...styles.colBillDate}}>Bill Date</Text>
              <Text style={{...styles.headerText, ...styles.colTime}}>Time</Text>
              <Text style={{...styles.headerText, ...styles.colUhid}}>UHID</Text>
              <Text style={{...styles.headerText, ...styles.colOpNo}}>OP No</Text>
              <Text style={{...styles.headerText, ...styles.colPatientName}}>Patient Name</Text>
              <Text style={{...styles.headerText, ...styles.colGuardianName}}>Guardian</Text>
              <Text style={{...styles.headerText, ...styles.colAge}}>Age</Text>
              <Text style={{...styles.headerText, ...styles.colConsultant}}>Consultant</Text>
              <Text style={{...styles.headerText, ...styles.colAddress}}>Address</Text>
              <Text style={{...styles.headerText, ...styles.colCity}}>City</Text>
              <Text style={{...styles.headerText, ...styles.colState}}>State</Text>
              <Text style={{...styles.headerText, ...styles.colCategory}}>Category</Text>
              <Text style={{...styles.headerText, ...styles.colMobile}}>Mobile</Text>
              <Text style={{...styles.headerText, ...styles.colRefBy}}>Ref By</Text>
              <Text style={{...styles.headerText, ...styles.colEntryBy}}>Entry By</Text>
            </View>
            
            {/* Data Rows */}
            {data?.opdData?.data?.map((item, index) => (
              <View key={index} style={{...styles.dataRow, backgroundColor: COLORS[index % COLORS.length]}}>
                <Text style={{...styles.cellTextCenter, ...styles.colSrNo}}>{index + 1}</Text>
                <Text style={{...styles.cellTextCenter, ...styles.colBillDate}}>{formatDate(item.date)}</Text>
                <Text style={{...styles.cellTextCenter, ...styles.colTime}}>{formatTime(item.time)}</Text>
                <Text style={{...styles.cellText, ...styles.colUhid}}>{item?.uhid || ''}</Text>
                <Text style={{...styles.cellTextCenter, ...styles.colOpNo}}>{item?.op_no || ''}</Text>
                <Text style={{...styles.cellText, ...styles.colPatientName}}>
                  {`${item.name_suffix || ''} ${item.first_name || ''} ${item.last_name || ''}`.trim()}
                </Text>
                <Text style={{...styles.cellText, ...styles.colGuardianName}}>{item.guardian_name || ''}</Text>
                <Text style={{...styles.cellTextCenter, ...styles.colAge}}>{calculateAge(item.dob)}</Text>
                <Text style={{...styles.cellText, ...styles.colConsultant}}>{item.consultant?.name || ''}</Text>
                <Text style={{...styles.cellText, ...styles.colAddress}}>{item.address?.address || ''}</Text>
                <Text style={{...styles.cellText, ...styles.colCity}}>{item.city?.city || ''}</Text>
                <Text style={{...styles.cellText, ...styles.colState}}>{item.state?.state || ''}</Text>
                <Text style={{...styles.cellText, ...styles.colCategory}}>{item.sponsor?.name || ''}</Text>
                <Text style={{...styles.cellText, ...styles.colMobile}}>{item.address?.mobile || ''}</Text>
                <Text style={{...styles.cellText, ...styles.colRefBy}}>{item.ref_by || ''}</Text>
                <Text style={{...styles.cellText, ...styles.colEntryBy}}>{item.createdBy || ''}</Text>
              </View>
            ))}
            
            {/* Footer with summary */}
            <View style={styles.footer}>
              <Text>Total Records: {data?.opdData?.data?.length || 0}</Text>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};